import request from '@/utils/request';
export function messageLogList(data) {
  return request.post('admin/message-event/list', data);
}
export function pushScenarioResource(data) {
  return request.post('admin/scene/push-scenario/resource', data);
}
export function cancelMessgaeSend(data) {
  return request.post('admin/message-event/processing-status', data);
}
export function newMessageStore(data) {
  return request.post('admin/message-event/store', data);
}
export function messageLogDetail(data) {
  return request.post('admin/message-event/detail', data);
}